//
// Copyright 2023 DXOS.org
//

import { useContext } from 'react';

import { TranslationsContext } from '../providers/ThemeProvider/TranslationsContext.ts';

export const useTranslationsContext = () => useContext(TranslationsContext);
